import _ from 'lodash'
import { pointers } from '@wix/thunderbolt-becky-types'
import {
	DESIGN_INFLATED_MAP,
	PRESET_RESOLVING_DATA_ITEM_TYPE,
	RESOLVED_REFS_NAMESPACE,
	SITE_NAMESPACE,
} from '../../../constants'
import {
	defaultRefConsumptionDataNodeToViewItem,
	getDataItemRefsWithOverrides,
	resolveOverrideItem,
} from '../../dataConsumption'
import { getInflatedDataItemsMap } from '../../presetsResolving'
import type { DataItemWithOverridesRefs, DataRefsForPresetResolving } from '../../types'
import type { DependenciesData } from './types'
import { createConsumptionDataNode, getDataRefsForPresetResolving } from './utils/dataNodeUtils'
import { REPEATER_DELIMITER } from '@wix/thunderbolt-commons'
import type { Unref } from '@wix/thunderbolt-catharsis'

const isRepeaterItemOverride = (id: string) => id.includes(REPEATER_DELIMITER)
export const DesignData = createConsumptionDataNode<
	DependenciesData,
	DataRefsForPresetResolving | DataItemWithOverridesRefs,
	DataRefsForPresetResolving | DataItemWithOverridesRefs
>({
	getDependencies: (depsData) => {
		if (isRepeaterItemOverride(depsData.inflatedDataItemId)) {
			return {
				dataItemWithOverrides: getDataItemRefsWithOverrides(depsData),
			} as DataItemWithOverridesRefs
		}

		return getDataRefsForPresetResolving(depsData)
	},
	updateDependencies: ({ id, update, inflatedComponent, dependencies }) => {
		const { designQuery } = inflatedComponent
		if (isRepeaterItemOverride(id)) {
			update(RESOLVED_REFS_NAMESPACE, pointers.data.DATA_MAPS.DESIGN, id, dependencies, dependencies)
		} else {
			update(RESOLVED_REFS_NAMESPACE, DESIGN_INFLATED_MAP, designQuery, dependencies, dependencies)
		}
	},
	toViewItem: ({ id, value, rawModel }) => {
		if (isRepeaterItemOverride(id)) {
			return defaultRefConsumptionDataNodeToViewItem(id, value as Unref<DataItemWithOverridesRefs>)
		}

		const { refArraysWithOverrides } = value as Unref<DataRefsForPresetResolving>
		const templateDataItem = _.last(refArraysWithOverrides)
		if (!templateDataItem) {
			return
		}

		if (templateDataItem.type !== 'RefArray') {
			return { [id]: resolveOverrideItem(refArraysWithOverrides, id) }
		}

		const pageVariants = _.get(rawModel, [SITE_NAMESPACE, pointers.data.DATA_MAPS.VARIANTS], {})
		return getInflatedDataItemsMap(
			value as Unref<DataRefsForPresetResolving>,
			id,
			pageVariants,
			PRESET_RESOLVING_DATA_ITEM_TYPE[pointers.data.DATA_MAPS.DESIGN]
		)
	},
})
